module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-salons panel panel-default"
  }, [_c('div', {
    staticClass: "list-salons",
    attrs: {
      "data-infinite-scroll": ""
    }
  }, [_c('panel-search', {
    staticClass: "panel-search-light",
    attrs: {
      "placeholder": "Введите наименование для поиска"
    },
    on: {
      "search": _vm.search
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.salons), function(salon) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(salon.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(salon.users_count))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(salon.supervisor ? salon.supervisor.full_name : ''))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      staticClass: "btn btn-sm btn-delete",
      attrs: {
        "href": ("/salons/" + (salon.id) + "/edit")
      }
    }, [_vm._v("Редактировать")])])])
  }))]), _vm._v(" "), (_vm.next_page_url) ? _c('button', {
    staticClass: "load-more",
    on: {
      "click": _vm.loadNextPage
    }
  }, [_vm._v("Еще")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Салон")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Привязано работников")]), _vm._v(" "), _c('th', [_vm._v("ФИО")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Действие")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b3b2b494", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3b2b494"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ListSalons.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b3b2b494"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ListSalons.vue
// module chunks = 0